import React, { useState } from 'react';
import { useContext, useEffect, useRef } from "react";
import FormConfig from '../../Config/FormConfig';
import APIService from '../../Service/APIService';
import { Button, Input, Row, Col, Spin, Table, DatePicker, message, Upload } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import './InvoiceFormCss.css';
import { Formik } from 'formik';
// import moment from 'moment';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import { LoadingOutlined } from '@ant-design/icons';
import * as yup from 'yup';
import { debounce } from 'lodash';

const InvoiceForm = (props) => {
  // const [invoiceData, setInvoiceData] = useState();
  const { orderType, orderData } = props;
  const [fieldsArr, setFieldsArr] = React.useState([]);
  const [orderProducts, setOrderProducts] = React.useState(null);
  const [initialValues, setInitialValues] = React.useState(null);
  const [validationSchema, setValidationSchema] = React.useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const [invoiceTotal, setInvoiceTotal] = useState(0);
  const [prevData, setPrevData] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);

  const getInvoiceData = async () => {
    console.log("Inside Get Invoice Data");
    const apiServ = new APIService();
    const response = await apiServ.getDataFromBackend(`getinvoicedata?OrderID=${orderData.ID}&OrderType=${orderType}`);
    console.log("Invoice Data Response: ", response);
    const data = response?.data?.data;
    console.log("Invoice Data: ", data);
    // setInvoiceData(data);
    return data;
    // replace null with empty string
  }

  const getOrderProducts = async (tempInvoice) => {
    console.log("Inside Get Order Products");
    let response = null;
    const apiServ = new APIService();
    if (tempInvoice) {
      // getinvoiceproucts
      response = await apiServ.getDataFromBackend(`getinvoiceproucts?InvoiceID=${tempInvoice.ID}`);
      console.log("Order Products Response: ", response);
      const data = response?.data?.data;
      // replace null with empty string
      let newData = [];
      let j = 1;
      let totalSum = 0;
      data?.forEach((item) => {
        const obj = {
          ID: item["ID"],
          TissueID: item["TissueID"] ? item["TissueID"] : "",
          ProductID: item["ProductID"],
          ProductCode: item["ProductCode"],
          ProductName: item["ProductName"],
          ProductTotal: item["ProductTotal"],
          Price: item["Price"],
          OrderProductID: item["OrderProductID"],
          AccountID: orderData["AccountID"],
          AccountName: orderData["AccountName"],
          ManufacturerID: orderData["ManufacturerID"],
          ManufacturerName: orderData["ManufacturerName"],
          OrderID: orderData["OrderID"],
          OrderType: orderType,
          ExpirationDate: item["ExpirationDate"] === null ? null : dayjs(item["ExpirationDate"]),
          IsUsed: item["IsUsed"],
          // ShipDate: item["ShipDate"] === null ? null : moment(item["ShipDate"]),
          ShipDate: null,
          key: j++
        };
        totalSum += Number(item["Price"]);
        newData.push(obj);
      });
      setInvoiceTotal(totalSum);
      console.log("Order Products Data: ", newData);
      return { newData, totalSum };
    }
    else {
      response = await apiServ.getDataFromBackend(`getorderproducts?orderID=${orderData.ID}&orderType=${orderType}`);
      console.log("Order Products Response: ", response);
      const data = response?.data?.data;
      // replace null with empty string
      let newData = [];
      let j = 1;
      let totalSum = 0;
      data?.forEach((item) => {
        const qty = Number(item["Quantity"]);
        for (let i = 0; i < qty; i++) {
          const obj = {
            ID: item["ID"],
            TissueID: item["TissueID"] ? item["TissueID"] : "",
            ProductID: item["ProductID"],
            ProductCode: item["ProductCode"],
            ProductName: item["ProductName"],
            ProductTotal: item["ProductTotal"],
            Price: item["Price"],
            OrderProductID: item["ID"],
            AccountID: orderData["AccountID"],
            AccountName: orderData["AccountName"],
            ManufacturerID: orderData["ManufacturerID"],
            ManufacturerName: orderData["ManufacturerName"],
            OrderID: orderData["ID"],
            OrderType: orderType,
            ExpirationDate: item["ExpirationDate"],
            IsUsed: item["IsUsed"],
            // ShipDate: item["ShipDate"] === null ? null : moment(item["ShipDate"]),
            ShipDate: null,
            key: j++
          };
          totalSum += Number(item["Price"]);
          newData.push(obj);
        }
      });
      setInvoiceTotal(totalSum);
      console.log("Order Products Data: ", newData);
      return { newData, totalSum };
    }
  }

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    // console.log("Data: ", data);
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] =
          cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    return obj;
  }

  const generateValidationSchema = (formFieldArr) => {
    let obj = {}; // schema object
    for (const cur of formFieldArr) {
      obj[cur.backendName] = cur.validationFunction;
    }
    return obj;
  }

  const generateFieldsArray = () => {
    const invoiceFields = FormConfig.InvoiceForm;
    console.log("invoice fields: ", invoiceFields);
    setFieldsArr(invoiceFields);
    const val = generateInitialValues(invoiceFields, orderData);
    setValidationSchema(yup.object().shape(generateValidationSchema(invoiceFields)));
    console.log("Initial Values: ", val);
    val["OrderType"] = (val["OrderType"] === "DO" || val["OrderType"] === "Direct Order") ? "Direct Order" : val["OrderType"];
    val["InvoiceDate"] = val["InvoiceDate"] === null ? null : dayjs(val["InvoiceDate"]);
    val["InvoiceDueDate"] = val["InvoiceDueDate"] === null ? null : dayjs(val["InvoiceDueDate"]);
    if (val["UploadInvoiceFileName"]) {
      setUploadInvoiceFileBlobName(val["UploadInvoiceFileBlobName"]);
      setFileName(val["UploadInvoiceFileName"]);
      setUploadFileList([{ name: val["UploadInvoiceFileName"], status: "done", uid: "1" }]);
    }
    setInitialValues(val);
  };

  React.useEffect(() => {
    console.log("InvoiceForm component mounted");
    console.log("order data:", orderData);
    console.log("order type:", orderType);
    let tempInvoice = null;
    getInvoiceData().then((invoice) => {
      tempInvoice = invoice;
      if (invoice) {
        console.log("Invoice Data: ", invoice);
        setInvoiceData(invoice);
        const invoiceFields = FormConfig.InvoiceForm;
        setFieldsArr(invoiceFields);
        const val = generateInitialValues(invoiceFields, invoice);
        val["OrderType"] = (val["OrderType"] === "DO" || val["OrderType"] === "Direct Order") ? "Direct Order" : val["OrderType"];
        val["InvoiceDate"] = val["InvoiceDate"] === null ? null : dayjs(val["InvoiceDate"]);
        val["InvoiceDueDate"] = val["InvoiceDueDate"] === null ? null : dayjs(val["InvoiceDueDate"]);
        if (val["UploadInvoiceFileName"]) {
          setUploadInvoiceFileBlobName(val["UploadInvoiceFileBlobName"]);
          setFileName(val["UploadInvoiceFileName"]);
          setUploadFileList([{ name: val["UploadInvoiceFileName"], status: "done", uid: "1" }]);
        }
        setInitialValues(val);
      }
      else {
        generateFieldsArray();
      }
    }).then(() => {
      getOrderProducts(tempInvoice).then(({ newData, totalSum }) => {
        console.log("Get Order Products called");
        setOrderProducts(newData);
        setSelectedData(newData);
      }).catch((error) => {
        console.log("Error in getting order products: ", error);
      });
    });

    // setOrderProductsColumns(generateSchema());

  }, []);

  const calculateInvoiceTotal = (newData) => {
    const data = newData;
    let total = 0;
    data.map((ele) => {
      total += Number(ele.Price);
    });
    setInvoiceTotal(total);
  }

  // const handleInputChange = (e, key, column) => {
  //   const newData = selectedData.map(row => row.key === key ? { ...row, [column]: e.target.value } : row);
  //   setSelectedData(newData);
  //   if(column === 'Price') {
  //     calculateInvoiceTotal(newData);
  //   }
  // };

  const [tissueIDEdited, setTissueIDEdited] = useState(false);
  const handleInputChange = (e, key, column) => {
    const value = e.target.value;
    const newData = selectedData.map(row =>
      row.key === key ? { ...row, [column]: value } : row
    );
    setSelectedData(newData);

    if (column === "TissueID") {
      setTissueIDEdited(true);
      // Debounced server check
      checkTissueId(value, key, setTissueErrors);

      // Local duplicate check
      const localErrors = checkLocalDuplicates(newData);
      setTissueErrors(prev => ({
        ...prev,
        ...Object.keys(prev).reduce((acc, k) => {
          // preserve server errors for keys not overridden by local duplicate errors
          acc[k] = localErrors[k] ?? prev[k];
          return acc;
        }, {}),
        ...localErrors
      }));
    }

    if (column === 'Price') {
      calculateInvoiceTotal(newData);
    }
  };


  const [showLoader, setShowLoader] = useState(false);

  const saveHandler = async (values) => {
    setShowLoader(true);
    const valid = await validateBeforeAction();
    if (!valid) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Tissue IDs',
        text: 'Please fix duplicate Tissue IDs before submitting.'
      });
      setShowLoader(false);
      return;
    }
    console.log("Save Invoice");
    console.log("Values: ", values);
    console.log('products: ', selectedData);
    console.log("Order Data: ", orderData);
    // Swal.fire({
    //   title: 'Are you sure?',
    //   text: "Do you want to save?",
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   confirmButtonText: 'Yes',
    // }).then(async (result) => {
    //   if (result.isConfirmed) {
        // return;
        const apiServe = new APIService();
        // add new invoice
        const invoicePostObj = {
          OrderID: orderData.ID,
          OrderType: orderType,
          InvoiceDate: values.InvoiceDate,
          InvoiceDueDate: values.InvoiceDueDate,
          InvoiceNumber: values.InvoiceNumber,
          TrackingNumber: values.TrackingNumber,
          InvoiceTotal: invoiceTotal,
          PONumber: orderData.PONumber,
          InvoiceInAppeal: values.InvoiceInAppeal,
          ShippingCost: values.ShippingCost,
          AccountID: orderData.AccountID,
          AccountName: orderData.AccountName,
          ShipToAccountID: orderData.ShipToAccountID,
          ShipToAccountName: orderData.ShipToAccountName,
          ManufacturerID: orderData.ManufacturerID,
          ManufacturerName: orderData.ManufacturerName,
          // ShipDate: orderData.ShipDate,
          // ExpirationDate: orderData.ExpirationDate,
        };
        let invoiceProducts = [];
        selectedData.map((ele) => {
          if (orderType === "Direct Order" || orderType === "DO") {
            ele["IsUsed"] = true;
          }
          invoiceProducts.push(ele);
        });
        const postObj = {
          invoice: invoicePostObj,
          invoiceProducts: invoiceProducts,
          type: "Save",
          isFileUpdated: isFileUpdated,
        }
        let formData = new FormData();
        formData.append("data", JSON.stringify(postObj));
        formData.append("file", uploadInvoice);
        const invoiceResponse = await apiServe.addFileDataToBackend(formData, `addinvoice`, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        });
        console.log("Invoice Post Obj: ", invoicePostObj);
        // const invoiceResponse = await apiServe.addDataToBackend(postObj, `addinvoice?type=Save`);
        console.log("Invoice Response: ", invoiceResponse);
        if (invoiceResponse && invoiceResponse?.data) {
          Swal.fire({
            icon: 'success',
            text: 'Invoice Added Successfully',
            timer: 1500
          });
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
        else {
          Swal.fire({
            icon: 'error',
            text: 'Add Invoice Failed',
            timer: 1500
          });
        }
      // }
    //   else {
    //     setShowLoader(false);
    //   }
    // });
  }

  const checkLocalDuplicates = (data) => {
    const seen = {};
    const errors = {};
    data.forEach((row) => {
      const val = row.TissueID?.trim();
      if (!val) return; // skip empty
      if (seen[val]) {
        errors[row.key] = "Duplicate Tissue ID in this invoice";
      } else {
        seen[val] = true;
      }
    });
    return errors;
  };

  const waitForAllChecks = async () => {
    await Promise.all(pendingChecksRef.current);
  };

  const validateBeforeAction = async () => {
    await waitForAllChecks();
    // Final local duplicate check
    const localErrors = checkLocalDuplicates(selectedData);
    if (Object.keys(localErrors).length > 0) {
      setTissueErrors(prev => ({ ...prev, ...localErrors }));
      return false;
    }
    // Check combined errors
    return !Object.values(tissueErrors).some(err => err !== null);
  };

  const submitHandler = async (values, type) => {
    setShowLoader(true);
    const valid = await validateBeforeAction();
    if (!valid) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Tissue IDs',
        text: 'Please fix duplicate Tissue IDs before submitting.'
      });
      setShowLoader(false);
      return;
    }
    console.log("Submit Invoice");
    // console.log("Order Products: ", orderProducts);
    // console.log("Order Data: ", orderData);
    console.log("Values: ", values);
    console.log('products: ', selectedData);
    console.log("Order Data: ", orderData);

    // check if tissue ID Added
    if (type === "Complete") {
      let isValid = true;
      selectedData.map((ele) => {
        if (ele?.TissueID === null || ele?.TissueID === undefined || ele?.TissueID === '') {
          isValid = false;
        }
      });
      if (!isValid) {
        Swal.fire({
          icon: 'error',
          title: 'Tissue ID missing',
          text: 'Please add all the Tissue IDs',
        });
        setShowLoader(false);
        return;
      }

    }
    Swal.fire({
      title: 'Are you sure?',
      text: type === "Save" ? "Do you want to save?" : 'Do you want to add the invoice and mark the order as complete?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {
      if (result.isConfirmed) {
        // return;
        const apiServe = new APIService();
        // add new invoice
        const invoicePostObj = {
          OrderID: orderData.ID,
          OrderType: orderType,
          InvoiceDate: values.InvoiceDate,
          InvoiceDueDate: values.InvoiceDueDate,
          InvoiceNumber: values.InvoiceNumber,
          TrackingNumber: values.TrackingNumber,
          InvoiceTotal: invoiceTotal,
          PONumber: orderData.PONumber,
          InvoiceInAppeal: values.InvoiceInAppeal,
          ShippingCost: values.ShippingCost,
          AccountID: orderData.AccountID,
          AccountName: orderData.AccountName,
          ShipToAccountID: orderData.ShipToAccountID,
          ShipToAccountName: orderData.ShipToAccountName,
          ManufacturerID: orderData.ManufacturerID,
          ManufacturerName: orderData.ManufacturerName,
          // ShipDate: orderData.ShipDate,
          // ExpirationDate: orderData.ExpirationDate,
        };
        let invoiceProducts = [];
        selectedData.map((ele) => {
          if (orderType === "Direct Order" || orderType === "DO") {
            ele["IsUsed"] = true;
          }
          invoiceProducts.push(ele);
        });
        const postObj = {
          invoice: invoicePostObj,
          invoiceProducts: invoiceProducts,
          type: type,
          isFileUpdated: isFileUpdated,
        }
        let formData = new FormData();
        formData.append("data", JSON.stringify(postObj));
        formData.append("file", uploadInvoice);
        const invoiceResponse = await apiServe.addFileDataToBackend(formData, `addinvoice`, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        });
        console.log("Invoice Response: ", invoiceResponse);
        if (invoiceResponse && invoiceResponse?.data) {
          Swal.fire({
            icon: 'success',
            text: 'Invoice Added Successfully',
            timer: 1500
          });
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
        else {
          Swal.fire({
            icon: 'error',
            text: 'Add Invoice Failed',
            timer: 1500
          });
        }
      }
      else {
        setShowLoader(false);
      }
    });
  }

  const [tissueErrors, setTissueErrors] = useState({});
  const pendingChecksRef = useRef([]);
  const [isTissueIDFocused, setIsTissueIDFocused] = useState(false);

  const apiServ = new APIService();

  // Debounced checker (runs 500ms after typing stops)
  const checkTissueId = debounce(async (value, recordKey, setErrors) => {
    if (!value) {
      setErrors(prev => ({ ...prev, [recordKey]: null }));
      return;
    }
    const checkPromise = (async () => {
      try {
        const res = await apiServ.getDataFromBackend(`CheckForDuplicateTissueID?TissueID=${value}`);
        if (res.data.exists) {
          setErrors(prev => ({
            ...prev,
            [recordKey]: (
              <>
                Duplicate Tissue ID found in Invoice Number{' '}
                <a
                  href={`/InvoiceHome/${res.data?.invoice?.ID}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {res.data?.invoice?.InvoiceNumber}
                </a>
              </>
            )
          }));
        } else {
          setErrors(prev => ({ ...prev, [recordKey]: null }));
        }
      } catch {
        setErrors(prev => ({ ...prev, [recordKey]: "Error checking Tissue ID" }));
      }
    })();

    pendingChecksRef.current.push(checkPromise);
    await checkPromise;
    pendingChecksRef.current = pendingChecksRef.current.filter(p => p !== checkPromise);
  }, 500);

  const columns = [
    {
      title: 'Tissue ID',
      dataIndex: 'TissueID',
      width: '20%',
      render: (_, record) => (
        <>
          <Input
            defaultValue={record.TissueID}
            onFocus={() => setIsTissueIDFocused(true)}
            onBlur={(e) => {
              setIsTissueIDFocused(false);
              handleInputChange(e, record.key, 'TissueID');
            }}
            disabled={orderType === "Product Usage" ? true : false}
          />
          {tissueErrors[record.key] && (
            <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{tissueErrors[record.key]}</div>
          )}
        </>
      ),
      // render: (_, record) => renderTissueID(record),
    },
    {
      title: 'Product Code',
      dataIndex: 'ProductCode',
      width: '20%',
      render: (_, record) => (
        <Input
          value={record.ProductCode}
          disabled={true}
        />
      ),
    },
    {
      title: 'Product Cost',
      dataIndex: 'Price',
      width: '15%',
      // render: (_, record) => RenderPrice(record),
      render: (_, record) => (
        <Input
          defaultValue={record.Price}
          onBlur={e => handleInputChange(e, record.key, 'Price')}
          onPressEnter={e => handleInputChange(e, record.key, 'Price')}
        // disabled={true}
        />
      ),
    },
    {
      title: 'Ship Date',
      dataIndex: 'ShipDate',
      width: '15%',
      render: (_, record) => (
        <DatePicker
          format="MM-DD-YYYY"
          // onBlur={() => formik.setFieldTouched("RequestedDeliveryDate")}
          title={record.ShipDate}
          value={record.ShipDate}
          onChange={(date, dateString) =>
            setSelectedData(selectedData.map(row => row.key === record.key ? { ...row, ShipDate: date } : row))
          }
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'Expiration Date',
      dataIndex: 'ExpirationDate',
      width: '15%',
      render: (_, record) => (
        <DatePicker
          format="MM-DD-YYYY"
          // onBlur={() => formik.setFieldTouched("RequestedDeliveryDate")}
          title={record.ExpirationDate}
          value={record.ExpirationDate}
          onChange={(date, dateString) =>
            setSelectedData(selectedData.map(row => row.key === record.key ? { ...row, ExpirationDate: date } : row))
          }
          style={{ width: '100%' }}
        />
      ),
    },
  ];

  const puColumns = [
    {
      title: 'Tissue ID',
      dataIndex: 'TissueID',
      width: '20%',
      render: (_, record) => (
        <Input
          defaultValue={record.TissueID}
          onChange={e => handleInputChange(e, record.key, 'TissueID')}
          disabled={orderType === "Product Usage" ? true : false}
        />
      ),
    },
    {
      title: 'Product Code',
      dataIndex: 'ProductCode',
      width: '20%',
      render: (_, record) => (
        <Input
          value={record.ProductCode}
          disabled={true}
        />
      ),
    },
    {
      title: 'Product Cost',
      dataIndex: 'Price',
      width: '15%',
      render: (_, record) => (
        <Input
          // value={record.Price}
          // disabled={true}
          defaultValue={record.Price}
          onBlur={e => handleInputChange(e, record.key, 'Price')}
          onPressEnter={e => handleInputChange(e, record.key, 'Price')}
        />
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ style, ...restProps }) => (
        <th
          {...restProps}
          style={{
            ...style,
            backgroundColor: '#ffffff',
            color: '#000',
            borderColor: '#ffffff',
            paddingBottom: '2px',
            fontWeight: 500,
            marginTop: '8px',
          }}
        />
      ),
    },
    body: {
      cell: ({ style, ...restProps }) => (
        <td
          {...restProps}
          style={{
            ...style,
            backgroundColor: '#ffffff',
            color: '#000',
            borderColor: '#ffffff',
            paddingTop: '0px',
          }}
        />
      ),
    },
  };

  const [type, setType] = useState(null);

  const [uploadInvoice, setUploadInvoice] = React.useState(null);
  const [uploadFileList, setUploadFileList] = React.useState([]);
  const [isFileUpdated, setIsFileUpdated] = React.useState(false);
  const [fileName, setFileName] = React.useState(null);
  const [uploadInvoiceFileBlobName, setUploadInvoiceFileBlobName] = React.useState(null);

  const handleFile = async ({ file, onSuccess }) => {
    if (file.size > 4194304) {
      message.error("File size should be less than 4MB");
      setFileName(null);
      setUploadInvoice(null);
      setUploadFileList([]);
      return;
    }
    setIsFileUpdated(true);
    setUploadFileList([{ name: file.name, status: "done", uid: "1" }]);
    setUploadInvoice(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const downloadFile = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(uploadInvoiceFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }
    // download the file from Azure Blob Storage
    const link = document.createElement('a');
    link.href = sasUrl;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // console.log("Download File: ", tissueTracking);
    // const url = window.URL.createObjectURL(tissueTracking);

    // // Create a link element and trigger the download
    // const link = document.createElement("a");
    // link.href = url;
    // link.setAttribute("download", fileName); // Set the file name
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    // action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    accept: [".pdf"],
    // disabled: !isEditable,
    fileList: uploadFileList,
    customRequest: handleFile,
    onPreview: downloadFile,
    onRemove: (file) => {
      setUploadInvoice(null);
      setUploadFileList([]);
      setFileName(null);
    },
    onChange(info) {
      console.log("File Info: ", info);
      const { status } = info.file;
      // console.log("Status: ", status);
      if (status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (status === "done") {
        // setIvrReport(info.file.originFileObj);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <div>
      {/* {orderProducts && */}
      {showLoader &&
        <Spin fullscreen indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      }
      <div>
        {initialValues && (
          <Formik onSubmit={(values) => submitHandler(values, type)} initialValues={initialValues} validationSchema={validationSchema}>
            {(formik) => (
              // console.log("formik: ", formik),
              <form onSubmit={formik.handleSubmit}>
                <Row gutter={16}>
                  <Col span={8} style={{ width: '100%' }}>
                    <label className="form-label">PO Number</label>
                    <Input
                      name="PONumber"
                      value={formik.values.PONumber}
                      onBlur={() => formik.setFieldTouched("PONumber")}
                      // onChange={(event) => formik.setFieldValue('PONumber', event.target.value)}
                      defaultValue={formik.values.PONumber}
                      disabled={true}
                    />
                    <p className='input-subtitle'>Choose the PO Number you would like to add to invoice</p>
                  </Col>
                  <Col span={8} style={{ width: '100%' }}>
                    <label className="form-label">Order Type</label>
                    <Input
                      name="OrderType"
                      value={formik.values.OrderType}
                      onBlur={() => formik.setFieldTouched("OrderType")}
                      // onChange={(event) => formik.setFieldValue('PONumber', event.target.value)}
                      defaultValue={formik.values.OrderType}
                      disabled={true}
                    />
                  </Col>
                  <Col span={8} style={{ width: "100%" }}>
                    <label className="form-label">Upload Invoice</label>
                    <Upload {...uploadProps}>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </Col>
                </Row>
                <Row gutter={16}>
                  {(formik.values.OrderType !== "Consignment Order" || formik.values.OrderType === "CO") &&
                    <Col span={8} style={{ width: '100%' }}>
                      <label className="form-label">Invoice Number</label>
                      <Input
                        name="InvoiceNumber"
                        value={formik.values.InvoiceNumber}
                        onBlur={() => formik.setFieldTouched("InvoiceNumber")}
                        onChange={(event) => formik.setFieldValue('InvoiceNumber', event.target.value)}
                        defaultValue={formik.values.InvoiceNumber}
                        placeholder='Enter Invoice Number'
                      // disabled={true}
                      />
                      {formik.errors["InvoiceNumber"] && formik.touched["InvoiceNumber"] ? (
                        <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["InvoiceNumber"]}</div>
                      ) : null}
                    </Col>
                  }
                  {(orderType !== "Product Usage" && orderType !== "PU") &&
                    <Col span={8} style={{ width: '100%' }}>
                      <label className="form-label">Tracking Number</label>
                      <Input
                        name="TrackingNumber"
                        value={formik.values.TrackingNumber}
                        onBlur={() => formik.setFieldTouched("TrackingNumber")}
                        onChange={(event) => formik.setFieldValue('TrackingNumber', event.target.value)}
                        defaultValue={formik.values.TrackingNumber}
                        placeholder='Enter Tracking Number'
                      // disabled={true}
                      />
                    </Col>
                  }
                  <Col span={8} style={{ width: '100%' }}>
                    <label className="form-label">Shipping Cost</label>
                    <Input
                      name="ShippingCost"
                      value={formik.values.ShippingCost}
                      onBlur={() => formik.setFieldTouched("ShippingCost")}
                      onChange={(event) => formik.setFieldValue('ShippingCost', event.target.value)}
                      defaultValue={formik.values.ShippingCost}
                      placeholder='Enter Shipping Cost'
                    // disabled={true}
                    />
                  </Col>
                </Row>
                <Row gutter={16}>
                  {(formik.values.OrderType !== "Consignment Order" || formik.values.OrderType === "CO") &&
                    <Col span={8} style={{ width: '100%' }}>
                      <label className="form-label">Invoice Date</label>
                      <DatePicker
                        format="MM-DD-YYYY"
                        onBlur={() => formik.setFieldTouched("InvoiceDate")}
                        title={formik.values["InvoiceDate"]}
                        // placeholder={ele.placeholder}
                        value={formik.values.InvoiceDate}
                        onChange={(date, dateString) => {
                          formik.setFieldValue("InvoiceDate", date);
                          // formik.setFieldValue("InvoiceDueDate",date.add(60, 'days'));
                        }
                        }
                        style={{ width: '100%' }}
                      />
                      {formik.errors["InvoiceDate"] && formik.touched["InvoiceDate"] ? (
                        <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["InvoiceDate"]}</div>
                      ) : null}
                    </Col>
                  }
                  {(formik.values.OrderType !== "Consignment Order" || formik.values.OrderType === "CO") &&
                    <Col span={8} style={{ width: '100%' }}>
                      <label className="form-label">Invoice Due Date</label>
                      <DatePicker
                        format="MM-DD-YYYY"
                        onBlur={() => formik.setFieldTouched("InvoiceDueDate")}
                        title={formik.values["InvoiceDueDate"]}
                        // placeholder={ele.placeholder}
                        defaultValue={formik.values.InvoiceDate}
                        value={formik.values.InvoiceDueDate}
                        onChange={(date, dateString) =>
                          formik.setFieldValue(
                            "InvoiceDueDate",
                            date
                          )
                        }
                        style={{ width: '100%' }}
                      />
                      {formik.errors["InvoiceDueDate"] && formik.touched["InvoiceDueDate"] ? (
                        <div style={{ color: 'red', paddingTop: '4px', fontSize: '12px' }}>{formik.errors["InvoiceDueDate"]}</div>
                      ) : null}
                    </Col>
                  }
                  <Col span={8} style={{ width: '100%' }}>
                    {(orderType === "Consignment Order" || orderType === "CO") &&
                      <label className="form-label">Order Total</label>
                    }
                    {(orderType !== "Consignment Order" && orderType !== "CO") &&
                      <label className="form-label">Invoice Total</label>
                    }
                    <Input
                      name="InvoiceTotal"
                      value={invoiceTotal}
                      // onBlur={() => formik.setFieldTouched("InvoiceTotal")}
                      // onChange={(event) => formik.setFieldValue('InvoiceTotal', event.target.value)}
                      defaultValue={invoiceTotal}
                      placeholder='Enter Invoice Total'
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Table
                  columns={(orderType === "Product Usage" || orderType === "PU") ? puColumns : columns}
                  dataSource={selectedData}
                  pagination={false}
                  components={components}
                  rowKey="key"
                  bordered={false}
                />
                {/* {orderType !== "Consignment Order" && orderType !== "CO" && */}
                <>
                  {/* <Button type="primary" onClick={() => formik.handleSubmit()} style={{ background: '#27a907' }}>Add Invoice</Button> */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                    <Button type="primary"
                      onClick={(values) => {
                        setType("Save");
                        console.log("values: ", formik.values);
                        // formik.handleSubmit(values, type)
                        saveHandler(formik.values);
                      }}
                      style={{ background: '#27a907' }}
                      // disabled={tissueErrors && Object.values(tissueErrors).some(err => err !== null)}
                      disabled={isTissueIDFocused || (tissueErrors && Object.values(tissueErrors).some(err => err !== null))}

                    >
                      Save
                    </Button>
                    <Button type="primary"
                      onClick={(values) => {
                        setType("Complete");
                        formik.handleSubmit(values, type)
                      }}
                      style={{ background: '#27a907' }}
                      // disabled={tissueErrors && Object.values(tissueErrors).some(err => err !== null)}
                      disabled={isTissueIDFocused || (tissueErrors && Object.values(tissueErrors).some(err => err !== null))}

                    >
                      Save and Mark as Complete
                    </Button>
                  </div>
                </>
              </form>
            )}
          </Formik>
        )}

      </div>
    </div>
  );
};

export default InvoiceForm;